var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "0.62em",
    height: "1em",
    viewBox: "0 0 256 417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "m127.961 0l-2.795 9.5v275.668l2.795 2.79l127.962-75.638z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M127.962 0L0 212.32l127.962 75.639V154.158z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3c3b",
    d: "m127.961 312.187l-1.575 1.92v98.199l1.575 4.601l128.038-180.32z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M127.962 416.905v-104.72L0 236.585z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "m127.961 287.958l127.96-75.637l-127.96-58.162z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "m.001 212.321l127.96 75.637V154.159z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumLogo);
export default __webpack_public_path__ + "static/media/ethereum-logo.4d0fb75278f62e151a0edf1452b84a7d.svg";
export { ForwardRef as ReactComponent };